import comboComponent from "@/components/child/form/combo.vue";
import { Component } from "@/decorators";
import TiposMotivoMovimentacao from "@/models/enum/tiposMotivoMovimentacao";
import MotivoMovimentacaoEstoqueModel from "@/models/motivoMovimentacaoEstoque";
import MotivoMovimentacaoEstoqueService from "@/services/motivoMovimentacaoEstoque";

import EditComponentBase from "../editComponentBase";

import "../crud.scss";

@Component({
    components: {
        comboComponent,
    },
})
export default class MotivoMovimentacaoEstoqueEditComponent extends EditComponentBase<MotivoMovimentacaoEstoqueModel> {
    tiposMotivoMovimentacaoOptions: Array<Object> = [
        { text: "Devolução ao fornecedor", value: TiposMotivoMovimentacao.DevolucaoAoFornecedor },
        { text: "Perda por desvio de qualidade", value: TiposMotivoMovimentacao.PerdaPorDesviodeQualidade },
        { text: "Perda no processo", value: TiposMotivoMovimentacao.PerdanoProcesso },
        { text: "Perda por avaria", value: TiposMotivoMovimentacao.PerdaporAvaria },
        { text: "Perda por furto", value: TiposMotivoMovimentacao.PerdaporFurto },
        {
            text: "Perda por uso no controlede de qualidade",
            value: TiposMotivoMovimentacao.PerdaporUsoControledeQualidade,
        },
        { text: "Perda por vencimento", value: TiposMotivoMovimentacao.PerdaporVencimento },
        { text: "Recolhimento do fabricante", value: TiposMotivoMovimentacao.RecolhimentodoFabricante },
        { text: "Recolhimento pela anvisa", value: TiposMotivoMovimentacao.RecolhimentopelaAnvisa },
        { text: "Alteração Interna", value: TiposMotivoMovimentacao.AlteracaoInterna },
        { text: "Uso e consumo durante processo", value: TiposMotivoMovimentacao.UsoConsumoDuranteProcesso },
        { text: "Transferência para filial", value: TiposMotivoMovimentacao.TransferenciaParaFilial },
    ];

    private async beforeMount() {
        await this.setProps(
            new MotivoMovimentacaoEstoqueService(),
            "motivomovimentacaoestoque",
            new MotivoMovimentacaoEstoqueModel(),
        );
    }
}
